module.exports = __webpack_public_path__ + "img/Path_1005.1c52668f.png";